import React from 'react'


const PageFooter = () => (
    <div className="jm-page-footer" />
)

export default PageFooter